<template>
  <div class="requisition-page">
    <Loader :active="isLoading" message="অপেক্ষা করুন..." />
    <Navbar />
    <b-modal 
      v-model="showModal" 
      :title="modalTitle"
      :header-bg-variant="modalVariant"
      header-text-variant="light"
      ok-only
      centered
      ok-title="ঠিক আছে" 
      @ok="handleModalOk"
      @hidden="handleModalClose"
    >
      <p class="my-2 text-center" style="font-size: 1.1rem;">{{ modalMessage }}</p>
    </b-modal>
    
    <div class="header-section bg-white border-bottom">
      <div class="container py-5">
        <div class="row justify-content-center text-center">
          <div class="col-lg-8">
            <h2 class="page-title mb-3">Device Management</h2>
            <p class="text-muted mb-4">ড্রপ ডাউন অপশন থেকে ডিভাইস সিলেক্ট করুন।</p>
            
            <div class="search-wrapper shadow-sm">
              <v-select
                v-model="deviceSelected"
                :options="APIData.map(item => item.name)"
                placeholder="Search active devices..."
                @input="onChangeDevice"
                class="device-select"
              >
                <template #no-options>
                  Sorry, no matching devices found.
                </template>
              </v-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="album py-5 bg-light min-vh-100">
      <div class="container">
        
        <div v-if="!RUData || RUData.length === 0" class="text-center text-muted py-5">
          <p>Please select a device above to view details.</p>
        </div>

        <div class="row">
          <div v-for="ruData in RUData" :key="ruData.id" class="col-md-6 col-lg-6 mb-4">
            <div class="card device-card h-100 border-0">
              
              <div class="card-body d-flex flex-column">
                <div class="d-flex justify-content-between align-items-start mb-2">
                  <div>
                    <h5 class="card-title font-weight-bold mb-1">{{ ruData.name }}</h5>
                    <p class="card-text text-muted small">
                      <b-icon icon="x-circle" scale="2" variant="danger"></b-icon> {{ ruData.device_location }}
                    </p>
                    <p class="card-text text-muted small">
                      <b-icon icon="x-circle" scale="2" variant="danger"></b-icon> {{ ruData.area_name }},{{ ruData.zone_name }}
                    </p>
                  </div>
                  <div class="status-badge" :class="ruData.active ? 'status-active' : 'status-inactive'">
                    {{ ruData.active ? 'Active' : 'Inactive' }}
                  </div>
                </div>

                <hr class="my-3 opacity-50">

                <div class="mt-auto row g-1"> 
  
                  <div class="col-6 col-xl-3">
                    <button 
                      @click="selectedDevice(ruData)" 
                      class="btn btn-primary w-100 shadow-sm mt-2"
                    >
                      Refill
                    </button>
                  </div>
                
                  <div class="col-6 col-xl-3">
                    <button 
                      @click="tryselectedDevice(ruData)" 
                      class="btn btn-outline-danger w-100 shadow-sm mt-2"
                      title="Report Mismatch"
                    >
                      Mismatch
                    </button>
                  </div>
                
                  <div class="col-6 col-xl-3">
                    <button 
                      @click="logComplain(ruData)" 
                      class="btn btn-outline-info w-100 shadow-sm mt-2"
                      title="Complain"
                    >
                      Complain
                    </button>
                  </div>
                
                  <div class="col-6 col-xl-3">
                    <button 
                      @click="updateDeviceStatus(ruData)" 
                      class="btn btn-outline-success w-100 shadow-sm mt-2"
                      title="Everything is OK"
                    >
                      Status OK
                    </button>
                  </div>
                
                </div>
                
              </div>

            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { getAPI } from './axios-api.js'
  import Navbar from './components/Navbar.vue'
  import { mapState } from 'vuex'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import { brandColors } from './brandColors.js'
  import Loader from './components/Loader.vue'
  import { BModal, ModalPlugin } from 'bootstrap-vue'
  Vue.use(ModalPlugin)

  export default {
    name: 'Requisition', // Renamed from Posts to match file logic
    components: {
      Navbar,
      vSelect,
      Loader,
      'b-modal': BModal
    },
    data() {
      return {
          search: '',
          deviceSelected: '',
          trydeviceSelected: '',
          RUData: '', // Initialize as empty string or array
          brandColors,
          isLoading: false,
          showModal: false,
          modalTitle: '',
          modalMessage: '',
          modalVariant: 'info',
          shouldReloadOnClose: false
      }
    },
    computed: mapState(['APIData']),
    created () {
        getAPI.get('/requestName/',{ headers: { 
          Authorization: `Bearer ${localStorage.getItem('access_token')}` 
          } })
          .then(response => {
            this.$store.state.APIData = response.data["ruData"]
            console.log(response.data)
          })
          .catch(err => {
            console.log(err)
          })
    },
    methods : {
      selectedDevice(selectedDevice){
        this.$store.dispatch('DeviceInfo', selectedDevice)
        this.$router.push({name:'Requisition'})
      },
      tryselectedDevice(tryselectedDevice){
        this.$store.dispatch('DeviceInfo', tryselectedDevice)
        this.$router.push({name:'tryRequisition'})
      },
      logComplain(selectedDevice){
        this.$router.push({
          name:'complain',
          params: { 
          deviceData: selectedDevice
        }})
      },
      async onChangeDevice() {
            this.isLoading = true;
            this.RUData = [];
            var disdata = {}
            const payload = {
                name: this.deviceSelected
            }
            
            getAPI.post('/requestProduct/', payload, { headers: { 
                    Authorization: `Bearer ${localStorage.getItem('access_token')}` 
            }})
            .then(response => {
                disdata = response['data'];
                this.RUData = disdata['ruData']
            })
            .catch(err => {
                console.error("API Error", err);
                // Optional: Handle error UI here
            })
            .finally(() => {
                // 2. Stop Loading (runs on both success and error)
                this.isLoading = false;
            });
      },
      async updateDeviceStatus(device) {
        const value = await this.$bvModal.msgBoxConfirm(
          `আপনি কি নিশ্চিত যে ${device.name} ঠিক আছে (OK)?`, 
          {
            title: 'নিশ্চিত করুন',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            okTitle: 'হ্যাঁ',
            cancelTitle: 'না',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }
        );

        if (!value) return;
        console.log(device);

        this.isLoading = true;
        const payload = {
            device_name: device.name,
            is_ok: true
        };

        getAPI.post('/device_status_update/', payload, { 
            headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } 
        })
        .then(response => {
          this.showNotification("সফল হয়েছে", "ডিভাইস স্ট্যাটাস সফলভাবে রেকর্ড করা হয়েছে!", "success", false);
          console.log(response);
        })
        .catch(err => {
            console.error("Error updating status:", err);
            this.showNotification("ত্রুটি", "স্ট্যাটাস আপডেট করতে সমস্যা হয়েছে। আবার চেষ্টা করুন।", "danger");
        })
        .finally(() => {
            this.isLoading = false;
        });
      },
      showNotification(title, message, variant = 'primary', shouldReload = false) {
          this.modalTitle = title;
          this.modalMessage = message;
          this.modalVariant = variant;
          this.shouldReloadOnClose = shouldReload;
          this.showModal = true;
      },

      handleModalOk() {
          if (this.shouldReloadOnClose) this.$router.go();
          this.showModal = false;
      },
      
      handleModalClose() {
          if (this.shouldReloadOnClose) this.$router.go();
      },
    }
  }
</script>

<style scoped>
/* Page Layout */
.requisition-page {
  background-color: #f8f9fa;
}

/* Header Section */
.page-title {
  font-weight: 800;
  color: #2c3e50;
}

.search-wrapper {
  background: white;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

/* Customizing Vue Select */
.device-select {
  border: none;
  font-size: 1.1rem;
}

/* We need deep selectors to style inside the v-select component */
::v-deep .vs__dropdown-toggle {
  border: none;
  padding: 8px 10px;
}
::v-deep .vs__search::placeholder {
  color: #adb5bd;
}

/* Card Styling */
.device-card {
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.03);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
}

.device-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.08);
}

.card-title {
  color: #343a40;
  font-size: 1.15rem;
}

/* Status Badge */
.status-badge {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  padding: 4px 10px;
  border-radius: 20px;
  letter-spacing: 0.5px;
}

.status-active {
  background-color: #e6f9ed;
  color: #28a745;
  border: 1px solid #d3eedd;
}

.status-inactive {
  background-color: #fff5f5;
  color: #dc3545;
  border: 1px solid #fddddd;
}

/* Button Styling */
.btn {
  border-radius: 6px;
  padding: 8px 16px;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.btn-primary {
  background-color: #90288b; /* Modern Blue */
  border-color: #90288ba1;
}

.btn-primary:hover {
  background-color: #ffffff;
  border-color: #90288b;
  color:#90288b;
}

/* Responsive Tweaks */
@media (max-width: 768px) {
  .page-title {
    font-size: 1.5rem;
  }
}
</style>